// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"664":"afd9145a","787":"6352a172","802":"83bb1ad7"}[chunkId] + ".chunk.js";
};